
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import DivSpan from '@/components/DivSpan';
import baseInfo from './base-info';
import contact from './contact';
import bankInfo from './bank-info';
import manageInfo from './manage-info';
import procureOrgan from './procure-organ';
import supplyCategory from './supply-category';
import qualificationInfo from './qualification-info';
import supOverview from './sup-overview';
import supplierDynamicFormValue from '@/components/supplier-dynamic-form-value';

export default {
directives: {
TransferDom
},
components: {
Grid,
GridItem,
DivSpan,
Popup,
supOverview,
baseInfo,
contact,
bankInfo,
manageInfo,
procureOrgan,
supplyCategory,
qualificationInfo,
supplierDynamicFormValue
},
data() {
return {
supplierId: null,
supplierDetail: {},
show: false,
moduleList: [],
allList: [
{icon: "icon-ability", color: '#5BAAF9', module: 'overview'},
{icon: "icon-information", color: "#37CC68", module: 'BASIC_INFO'},
{icon: "icon-trophy", color: "#FFBF4F", module: 'RESERVED_1'},
{icon: "icon-contact", color: "#5BAAF9", module: 'SUP_CONTACT'},
{icon: "icon-bar-chart", color: "#37CC68", module: 'RESERVED_2'},
{icon: "icon-bank_account", color: "#FFBF4F", module: 'SUP_BANK'},
{icon: "icon-adress", color: "#5BAAF9", module: 'RESERVED_3'},
{icon: "icon-file", color: "#37CC68", module: 'SAP_ECC'},
{icon: "icon-field", color: "#FFBF4F", module: 'KING_DEE'},
{icon: "icon-document", color: "#5BAAF9", module: 'RESERVED_4'},
{icon: "icon-fujian", color: "#37CC68", module: 'RESERVED_5'},
{icon: "icon-detal", color: "#FFBF4F", module: 'RESERVED_6'},
{icon: "icon-manege", color: "#5BAAF9", module: 'MANAGE_INFO'},
{icon: "icon-gongsixinxi", color: "#37CC68", module: 'RESERVED_7'},
{icon: "icon-organize", color: "#FFBF4F", module: 'SUP_ORGSTATUS'},
{icon: "icon-information", color: "#37CC68", module: 'RESERVED_8'},
{icon: "icon-default", color: "#FFBF4F", module: 'SUP_QUAL'},
{icon: "icon-variety", color: "#5BAAF9", module: 'SUP_SUPPLY_CAT'},
],
showModule: 'overview',
overBaseInfo: {},
reserved_1Code: '',
reserved_2Code: '',
reserved_3Code: '',
reserved_4Code: '',
reserved_5Code: '',
reserved_6Code: '',
reserved_7Code: '',
reserved_8Code: '',
sap_eccCode: '',
kingDeeCode: '',
questionaryId: null
}
},

methods: {
showMore() {
this.show = true;
},

getModuleList() {
let paramObj = {'supplierId': this.supplierId};
let paramStr = JSON.stringify(paramObj);
let menuCode = '';
if (this.$route.query.id === 'mine') {
menuCode = 'SUPPLIER_OWN';
} else {
menuCode = 'SUPPLIER'
}
this.$loadingShow();
this.$get('api/config-menu/find-by-code', {code: menuCode, param: paramStr}).then((res) => {
this.moduleList = [];
if (res && res[1] && res[1].children) {
res[1].children.forEach((item) => {
let obj = JSON.parse(item.moduleName);
let str;
for (let key in obj) {
str = key;
}
let arr = this.allList.filter((item) => {
return item.module === str;
});
if (arr[0]) {
arr[0].name = item.title;
this.moduleList.push(arr[0]);

}
})
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},

getSupplier() {
this.$loadingShow();
this.$get(`api/supplier/get-module-all-module?supplierId=${this.supplierId}`).then((res) => {
this.supplierDetail = res;
this.questionaryId = res.questionaryId;
let obj = {};
if (res.supBasicInfo) {
obj.shortName = res.supBasicInfo.shortName;
obj.vatCode = res.supBasicInfo.vatCode;
obj.supClassify = res.supBasicInfo.supClassify;
obj.statusName = res.statusName;
obj.supLevelName = res.supLevelName;
}
if (res.supSupplyCatList) {
let arr = [];
res.supSupplyCatList.forEach((item) => {
arr.push(item.supplyTypeName);
});
obj.supplys = arr.join(',');
}
this.overBaseInfo = obj;
this.getStatus();
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
},
getData() {
if (this.$route.params.id !== 'mine') {
this.supplierId = this.$route.params.id;
this.getModuleList();
this.getSupplier();
} else {
this.$get('api/supplier/current-sample').then((data) => {
this.supplierId = data.id;
this.getModuleList();
this.getSupplier();
})
}
},
backSupplierList() {
if (this.$store.state.device === 'wap') {
this.$router.go(-1);
} else {
document.location = "http://action:10002/?";
}
},
changeShow(str) {
this.showModule = str;
this.show = false;
},
getStatus() {
if (this.questionaryId) {
for (let i = 1; i < 9; i++) {
let param = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName: `RESERVED_${i}`
};
this.$get('api/supplier/get-dynamic-form', param).then((res) => {
this[`reserved_${i}Code`] = res.dynamicFormCode;
});
}
let param1 = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName: `SAP_ECC`
};
this.$get('api/supplier/get-dynamic-form', param1).then((res) => {
this[`sap_eccCode`] = res.dynamicFormCode;
});
let param2 = {
questionaryId: this.questionaryId,
supplierId:this.supplierId,
moduleName: `KING_DEE`
};
this.$get('api/supplier/get-dynamic-form', param2).then((res) => {
this[`kingDeeCode`] = res.dynamicFormCode;
});
}
}
},
mounted() {
this.getData();
}
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/view.vue